export default function ComparisonSection() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="text-center mb-8 md:mb-10">
        <span className="inline-block bg-secondary-100 text-secondary-700 text-xs font-semibold px-3 py-1 rounded-full mb-4">
          Vergleich
        </span>
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
          OOPBuy Spreadsheet vs klassische Produktsuche
        </h2>
        <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
          Ein direkter Vergleich zeigt die deutlichen Vorteile des OOPBuy Spreadsheet gegenüber herkömmlichen Suchmethoden
        </p>
      </div>

      <div className="max-w-2xl mx-auto bg-background-50 border border-background-200/70 rounded-2xl p-6 md:p-8 overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b-2 border-background-200/70">
              <th className="text-left py-4 pr-4 text-foreground-700 font-semibold whitespace-nowrap">Faktor</th>
              <th className="text-left py-4 pr-4 text-primary-600 font-semibold whitespace-nowrap">
                <i className="ri-star-fill text-xs mr-1"></i>
                OOPBuy Spreadsheet
              </th>
              <th className="text-left py-4 text-foreground-600 font-semibold whitespace-nowrap">Normale Suche</th>
            </tr>
          </thead>
          <tbody>
            {[
              { factor: "Zeitaufwand", oopbuy: "Gering", normal: "Hoch" },
              { factor: "Übersicht", oopbuy: "Sehr gut", normal: "Schlecht" },
              { factor: "Vergleich", oopbuy: "Einfach", normal: "Schwierig" },
              { factor: "Anfängerfreundlich", oopbuy: "Hoch", normal: "Mittel" },
              { factor: "Produktqualität", oopbuy: "Geprüft", normal: "Unbekannt" },
              { factor: "Aktualität", oopbuy: "Regelmäßig", normal: "Unregelmäßig" },
            ].map((row, idx) => (
              <tr key={row.factor} className={idx % 2 === 0 ? "bg-background-50" : "bg-background-100/50"}>
                <td className="py-3.5 pr-4 text-foreground-800 font-medium whitespace-nowrap">{row.factor}</td>
                <td className="py-3.5 pr-4 text-primary-600 font-semibold whitespace-nowrap">
                  <span className="flex items-center gap-1">
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-check-line text-xs"></i>
                    </div>
                    {row.oopbuy}
                  </span>
                </td>
                <td className="py-3.5 text-foreground-500 whitespace-nowrap">{row.normal}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </section>
  );
}